import { cn } from '@/components/ui/utils';
import React from 'react';
import { InferBaseHtmlType } from '../utils';

type BaseType = React.ComponentProps<'i'>;
export type TappTemplateProps = { size?: number | string } & BaseType;

export const TappIcon = React.forwardRef<InferBaseHtmlType<BaseType>, TappTemplateProps>(
  ({ size = 20, className, children, ...props }, forwardedRef) => {
    const pxSize = `${size}${typeof size === 'number' ? 'px' : ''}`;
    return (
      <i
        className={cn('material-symbols-rounded overflow-hidden leading-none text-[inherit]', className)}
        style={{ fontSize: pxSize, width: pxSize, height: pxSize }}
        ref={forwardedRef}
        {...props}
      >
        {children}
      </i>
    );
  }
);
